import { config, LdbdTheme } from 'display/config'
import ViewportSize from 'display/ViewportSize'
import { camerasConfig, camerasTheme } from 'shared/config'

export default function globalCssVars() {
	const globalTheme = config.vals.globalTheme
	const raceTheme = config.vals.raceTheme
	const ldbdTheme = config.vals.ldbdTheme
	const camerasConfig = config.vals.camerasConfig
	const camerasTheme = config.vals.camerasTheme

	return {
		'--global-font': globalTheme.font,
		'--col-heading-bg': globalTheme.colHeadingBg,
		'--col-heading-text': globalTheme.colHeadingText,
		'--finish-color-1': globalTheme.finishColor1,
		'--finish-color-2': globalTheme.finishColor2,
		'--lane-color-1': globalTheme.laneColor1,
		'--lane-color-2': globalTheme.laneColor2,
		'--place-bg-color': globalTheme.placeBgColor,
		'--place-text-color': globalTheme.placeTextColor,
		'--gutter-color': globalTheme.gutterColor,
		'--header-height': ViewportSize.headerHeight + 'px',
		'--marker-size': ViewportSize.markerSize + 'px',
		'--vitals-shadow': raceTheme.vitalTextShadow ? 'black' : 'transparent',
		'--ldbrd-elimination-line-width': ldbdTheme.ldbrdEliminationLineWidth + 'px',
		'--elimination-line-color': globalTheme.eliminationLineColor,
		'--segment-line-width': raceTheme.segmentLineWidth + 'px',
		'--camerasWgtHeight': camerasTheme.height * ViewportSize.height + 'px',
		'--camerasWgtWidth': camerasTheme.wgtWidth + 'px',
		'--camerasWgtPadding': camerasTheme.wgtPadding + 'px',
		'--wgtTimeFontSize': camerasTheme.timeFontSize + 'px',
		'--wgtTimeColor': camerasTheme.timeColor,
		'--wgtRaceNameHeight': camerasTheme.raceNameHeight + 'px',
		'--wgtRaceNameColor': camerasTheme.raceNameColor,
		'--camerasBgColor': camerasTheme.bgColor,
		'--wgtClassLabelColor': camerasTheme.classLabelColor,
		'--wgtTableHeaderHeight': camerasTheme.wgtTableHeaderHeight + 'px',

	}
}
